import { type Height, Image, type Width } from "@drone-js/core";
import type { FunctionComponent } from "react";

export interface IBrandLogo {
    src: string;
    alt: string;
    width: Width;
    height: Height;
}

const BrandLogo: FunctionComponent<IBrandLogo> = (props) => {
    return <Image {...props} />;
};

export default BrandLogo;
